<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container
            class="fluid grid-list-xl"
            style="height: 100%;"
    >
        <v-layout class="row wrap">
            <v-flex class="xs9" >
                <span style="font-weight: bold; font-size: 17px;">주차장 관리</span>
            </v-flex>
            <v-flex class="xs3" style="padding-top: 0px; padding-bottom: 0px;">
                <v-text-field
                        placeholder="search"
                        solo
                        v-model="search"
                        prepend-inner-icon="search"
                        label="Search"
                        clearable
                        class="ma-0 hide-details hide-messages"
                ></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout class="row wrap">
            <v-flex >
                <v-data-table
                        :headers="headers"
                        :items="parkinglots"
                        :search="search"
                        hide-actions
                        class="elevation-1"
                >
                    <template slot="items" slot-scope="items">
                        <td class="text-xs-center">{{ items.item.ParkingLotIDX }}</td>
                        <td class="text-xs-center">{{ items.item.Name }}</td>
                        <td class="text-xs-center">{{ items.item.Address }}</td>
                        <td class="text-xs-center">{{ items.item.Tel }}</td>
                        <td class="text-xs-center">{{ items.item.Account }}</td>
                        <td class="text-xs-center">{{ items.item.MaxCap }}</td>
                        <td class="text-xs-center">{{ items.item.Current }}</td>
                        <td class="text-xs-center">{{ items.item.Waiting }}</td>
                        <td class="text-xs-center" style="width: 200px;">
                            <v-btn color="success" style="width: 80px;" @click="edit_dialog = true; edit_valid = true; edit_new = false; edit_item = tool_app.copy(items.item); ">수정</v-btn>
                            <v-btn color="success" style="width: 80px;" @click="item_delete(items.item)">삭제</v-btn>
                        </td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
<!--        <v-btn-->
<!--                color="success"-->
<!--                @click="getList()"-->
<!--        >getList-->
<!--        </v-btn>-->

        <v-btn class="v-btn v-btn--floating v-btn--bottom v-btn--fixed v-btn--right pink" round style="width: 60px; height: 60px; margin-right:15px; "
                @click="edit_dialog = true; edit_valid = true; edit_new = true; edit_item = {}; " >
            <v-icon>add</v-icon>
        </v-btn>

        <v-dialog v-model="edit_dialog" persistent max-width="400px">
            <v-card>
                <v-card-text>
                    <span style="font-weight: bold; font-size: 17px;" v-if="edit_new === true">주차장 생성</span>
                    <span style="font-weight: bold; font-size: 17px;" v-if="edit_new === false">주차장 수정</span>
                    <v-container grid-list-md>
                        <v-form ref="edit_form"
                                v-model="edit_valid"
                                lazy-validation>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-text-field label="Name"
                                                  v-model="edit_item.Name"
                                                  :rules="edit_name_rules"
                                                  :disabled="edit_new === false"></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field label="Address"
                                                  v-model="edit_item.Address"
                                                  :rules="edit_address_rules"></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field label="Tel."
                                                  v-model="edit_item.Tel"
                                                  :rules="edit_tel_rules"></v-text-field>
                                </v-flex>
                                <v-flex xs12>
<!--                                    <v-select-->
<!--                                            :items="[10, 20, 30]"-->
<!--                                            label="Max Cap*"-->
<!--                                            v-model="edit_item.MaxCap"-->
<!--                                            :rules="edit_exist_rules"></v-select>-->
                                    <v-text-field label="Max Cap*"
                                                  v-model="edit_item.MaxCap"
                                                  :rules="edit_number_rules"></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="edit_dialog = false">취소</v-btn>
                    <v-btn color="blue darken-1" flat @click="edit_submit()">저장하기</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


    </v-container>
</template>

<script>
  import StatsCard from '../../components/material/StatsCard';
  import Test from '../../components/core/Test';
  import UserButton from '../../components/core/UserButton';
  import tool_app from '../../utils/tool_app';

  function lg (...args) { tool_app.lg('ParkingLotManage] ', ...args); }

  let comp = null;
  export default {
    components: { UserButton, Test, StatsCard, },
    data () {
      return {
        tool_app: tool_app,

        edit_dialog: false,
        edit_valid: true,
        edit_new: false,
        edit_item: {},
        // edit_name: '',
        edit_name_rules: [
          v => !!v || '입력해주세요..',
          // v => v.length >= 3 || '3자 이상 입력해주세요..'
        ],
        // edit_address: '',
        edit_address_rules: [
          v => !!v || '입력해주세요..',
          // v => v.length >= 6 || '6자 이상 입력해주세요..'
        ],
        // edit_tel: '',
        edit_tel_rules: [
          v => !!v || '입력해주세요..',
          // v => v.length >= 6 || '6자 이상 입력해주세요..'
        ],
        // edit_maxcap: 10,
        edit_number_rules: [
          v => !!v || '입력해주세요..',
          v => !!(tool_app.isNumeric(v)) || '숫자만 입력해주세요..',
        ],
        edit_exist_rules: [
          v => !!v || '선택해주세요..',
        ],

        search: '',
        parkinglots: [
        ],

        headers: [
          // {text: 'No', value: 'ListadoProductoId', sortable: false},
          // {text: 'Nombre', value: 'ListadoProducto.nombre'},
          // {text: 'Precio', value: 'ListadoProducto.precio'},
          // {text: 'Disponible (u)', value: 'disponible'},
          // {text: 'Limite faltantes', value: 'ListadoProducto.lim_falt'},
          // {text: 'Limite excedentes', value: 'ListadoProducto.lim_exc'}
          // {text: 'No', value: 'ListadoProductoId'},
          {text: 'No', value: 'ParkingLotIDX', align:'center',},
          {text: 'Name', value: 'Name', align:'center',},
          {text: 'Address', value: 'Address', align:'center',},
          {text: 'Tel.', value: 'Tel', align:'center',},
          {text: 'Account', value: 'Account', align:'center',},
          {text: 'Max Cap.', value: 'MaxCap', align:'center',},
          {text: 'Current', value: 'Current', align:'center',},
          {text: 'Waiting', value: 'Waiting', align:'center',},
          {text: '', value: '', sortable: false },
        ],
      }
    },
    created: function () {
      comp = this;
      comp.getList();
    },
    methods: {
      item_delete(item) {
        lg('item_delete 1 item:', tool_app.showObject(item));
        comp.$dialog.confirm(item.Name + '을 정말 삭제하시겠습니까?')
          .then(async (dialog) => {
            lg('item_delete confirm');
            tool_app.api(comp,`
            UPDATE T_ParkingLot
            SET IsExist = false
            WHERE ParkingLotIDX = ?
            `, [ item.ParkingLotIDX, ])
              .setShowProgressDialog()
              .send()
              .then((value) => {
                lg('item_delete 3 value:', value);
                comp.getList();
                comp.$dialog.alert('삭제가 완료되었습니다.');
              })
              .catch((reason) => {
                tool_app.ex(reason);
                comp.$dialog.alert(JSON.stringify(reason, null, 2));
              });
          });
      },
      edit_submit () {
        lg('edit_submit 1 ');
        if (comp.edit_dialog && comp.$refs.edit_form.validate()) {
          lg('edit_submit 2 this.edit_dialog:', this.edit_item.Name);

          if(comp.edit_new) {
            tool_app.api(comp, 'INSERT INTO T_ParkingLot (Name, Address, Tel, MaxCap, DateTime_Created, DateTime_Modified) VALUES (?, ?, ?, ?, NOW(), NOW())',
              [ comp.edit_item.Name, comp.edit_item.Address, comp.edit_item.Tel, comp.edit_item.MaxCap, ])
              .setShowProgressDialog()
              .send()
              .then((value) => {
                lg('edit_submit 3 value:', value);
                comp.edit_dialog = false;
                comp.getList();
              })
              .catch((reason) => {
                tool_app.ex(reason);
                comp.$dialog.alert(JSON.stringify(reason, null, 2));
              });
          }
          else {
            tool_app.api(comp,`
            UPDATE T_ParkingLot
            SET Name = ?, Address = ?, Tel = ?, MaxCap = ?, DateTime_Modified = NOW()
            WHERE ParkingLotIDX = ?
            `, [ comp.edit_item.Name, comp.edit_item.Address, comp.edit_item.Tel, comp.edit_item.MaxCap, comp.edit_item.ParkingLotIDX, ])
              .setShowProgressDialog()
              .send()
              .then((value) => {
                lg('edit_submit 3 value:', value);
                comp.edit_dialog = false;
                comp.getList();
              })
              .catch((reason) => {
                tool_app.ex(reason);
                // TODO
                comp.$dialog.alert(JSON.stringify(reason, null, 2));
              });
          }
        }
      },
      async getList() {
        lg('getList 1 ', comp);
        tool_app.api(comp, 'SELECT * FROM T_ParkingLot WHERE IsExist = true;',
          [])
          .setShowProgressDialog()
          .send()
          .then(function(value) {
            // lg('getList 2 value:', value);
            lg('getList 2 value:', value.data.results);
            comp.parkinglots = value.data.results;
          })
          .catch((reason) => {
            tool_app.ex(new Error(JSON.stringify(reason, null, 2)));
          });
      },
    }
  }
</script>
